<div class="mat-dialog-container">
  <!-- 明細編輯開始 -->
  <div #head>
    <app-modal-header #modal_header [isDialog]="true" [title]="title" [state]="srv.state" (onOkClick)="doOk($event)"
      (onCancelClick)="doCancel($event)" [user1Text]="'新增'" [user1Visible]="true" (onUser1Click)="doInsertModi()"
      [cancelVisible]="false">
    </app-modal-header>
  </div>
  <mat-toolbar class="h-8">
    <mat-form-field>
      <mat-label>篩選</mat-label>
      <input matInput (keyup)="tableSrv.applyFilter($event)" #input>
    </mat-form-field>
    <button [matBadge]="srv.itemList().length" matBadgeColor="warn" class="btn-primary"
      (click)="doRefresh()">重新整理</button>
    <button class="btn-primary" (click)="doInsertModi()">
      <mat-icon fontIcon="add"></mat-icon>
    </button>
  </mat-toolbar>
  <table mat-table [dataSource]="tableSrv.tableDataSource" matSort>
    <!-- Name Column -->
    <ng-container matColumnDef="WL001">
      <th mat-header-cell *matHeaderCellDef> * </th>
      <td mat-cell *matCellDef="let item" style="height: 12px;">
        <mat-toolbar class="h-12">
          <app-jkdatefield labelMode="floating" label="" style="width: 210px;" [styleDisplay]="'flex'"
            [(value)]="item.WL005" [showClearButton]="false">
          </app-jkdatefield>
          <button class="btn-info" (click)="doEditAndSave(item)">存檔</button>
          <button class="btn-warning" (click)="doUIDelete(item)">刪除</button>
        </mat-toolbar>
        <mat-toolbar>
          <app-jkcheckboxYN [label]="'星號'" [(valueYN)]="item.WL008" [styleDisplay]="'flex'">
          </app-jkcheckboxYN>
          <app-jkedit [label]="'主旨'" style="font-size: larger;color: blue; width: 210px;" [styleDisplay]="'flex'"
            [(value)]="item.WL007" [required]="true">
          </app-jkedit>
        </mat-toolbar>

        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/quill@2.0.0-rc.5/dist/quill.bubble.css" />
        <quill-editor #editor class="w-full jk-component-border" matTooltip="html編輯,區域選擇出現功能表"
          [ngModel]="text2html(item.WL004)" [theme]="'bubble'" [modules]="quillEditorOptions"
          (onContentChanged)="quillEditorReady($event)">
        </quill-editor>
      </td>
    </ng-container>
    <tr mat-row (click)="tableSrv.tableRowClick(row)" *matRowDef="let row; columns: tableSrv.displayedColumns;"></tr>
  </table>
  <mat-paginator #paginator [pageSizeOptions]="[10, 100, 1000]" aria-label="Select page of users"
    (ready)="doComReady($event, 'paginator')">
  </mat-paginator>

</div>

